import { render, staticRenderFns } from "./NormalSearchNav480.vue?vue&type=template&id=107fcf00&scoped=true"
import script from "./NormalSearchNav480.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav480.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107fcf00",
  null
  
)

export default component.exports